/**
 * Resolves the `parentTerritoryIds` exposed on a niche-card row.
 *
 * Promoted-Niche scoped surfaces (e.g. the scoped route
 * `/category/:categoryId/niche/:nicheId`) need the copy-query button to emit
 * `(promotedId) AND (cardNicheQuery)` instead of the niche's natural
 * `allParents`. They pass `[scopeId]` as the override.
 *
 * Unified rule: when an override is provided (including an empty array),
 * it wins. Otherwise we fall back to today's `Niche.allParents` mapping.
 */
export const resolveParentTerritoryIds = (
  data: { __typename?: string; allParents?: ReadonlyArray<{ territoryId: string }> | null } | null | undefined,
  override?: string[]
): string[] => {
  if (override !== undefined) {
    return override
  }

  if (data?.__typename !== 'Niche') {
    return []
  }

  return data?.allParents?.map(parent => parent.territoryId) ?? []
}
